import React from 'react'

function Watches() {
  return (
    <div>Watches</div>
  )
}

export default Watches